import { Injectable } from '@angular/core';
import { _ } from 'underscore';
import { config } from 'src/app/app.config';
import { ShareData } from 'src/app/app.share-data';

@Injectable({
  providedIn: 'root'
})
export class ServiceLogsService {
  //#region Variable Zone
  public SERVICE_LOGS = config.baseURL+'SERVICE_LOGS';
  //#endregion

  //#region Contructor Zone
  constructor() { }
  //#endregion

  //#region Function Utility Zone
  public modifyServiceLog(service: any){
    try {
      ShareData.currentService = service;
      let tempService: any = window.localStorage.getItem(this.SERVICE_LOGS);
      let isMainService = _.filter(ShareData.allService, (n)=> {return n == service});
      if(tempService){
        tempService = JSON.parse(tempService);
        let hasData = true;
        for(let i = 0; i < tempService.length; i++){
          if(tempService[i].ServiceID == service.ServiceID){
            tempService[i].TimeStamp = new Date();
            hasData = false;
            break;
          }
        }
        if(hasData){
          service.TimeStamp = new Date();
          if(isMainService.length > 0){
            tempService.push(service);
          }
        }
        
      } else {
        if(isMainService.length > 0){
          service.TimeStamp = new Date();
          tempService = [service];
        }
        
      }
      if(tempService){
        window.localStorage.setItem(this.SERVICE_LOGS, JSON.stringify(tempService));
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
  //#endregion
}
